import { render, staticRenderFns } from "./OdemeTahsilatPlani.vue?vue&type=template&id=5ad29d4c&"
import script from "./OdemeTahsilatPlani.vue?vue&type=script&lang=js&"
export * from "./OdemeTahsilatPlani.vue?vue&type=script&lang=js&"
import style0 from "./OdemeTahsilatPlani.vue?vue&type=style&index=0&id=5ad29d4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports